import React from "react";
import { StepShell } from "@/components/StepShell";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { SYMPTOMS, FREQ_OPTIONS } from "@/lib/screeningData";
import { useI18n } from "@/i18n";
import { ClipboardList } from "lucide-react";

export const Questionnaire = ({ data, update }) => {
  const { t, tc } = useI18n();
  const s = data.symptoms;
  const toggle = (key, val) => update("symptoms", { flags: { ...s.flags, [key]: val } });

  return (
    <StepShell icon={ClipboardList} title={t("q_title")} subtitle={t("q_sub")} testId="questionnaire-step">
      <div className="rounded-xl border border-slate-200 bg-white p-6 sm:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {SYMPTOMS.map((sym) => {
            const checked = !!s.flags[sym.key];
            return (
              <label key={sym.key} htmlFor={`sym-${sym.key}`}
                className={`flex items-center gap-3 rounded-md border p-4 cursor-pointer transition-colors ${
                  checked ? "border-primary bg-primary/5" : "border-slate-200 hover:bg-slate-50"
                }`}>
                <Checkbox id={`sym-${sym.key}`} data-testid={`symptom-${sym.key}`} checked={checked}
                  onCheckedChange={(v) => toggle(sym.key, !!v)} />
                <span className="text-sm font-medium text-slate-700">{t("sym_" + sym.key)}</span>
              </label>
            );
          })}
        </div>

        <div className="mt-8">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("q_freq_label")}</Label>
          <RadioGroup className="mt-3 flex flex-wrap gap-3" value={s.frequenza}
            onValueChange={(v) => update("symptoms", { frequenza: v })}>
            {FREQ_OPTIONS.map((f) => (
              <label key={f} htmlFor={`freq-${f}`}
                className={`flex items-center gap-2 rounded-md border px-4 py-2.5 cursor-pointer transition-colors ${
                  s.frequenza === f ? "border-primary bg-primary/5" : "border-slate-200 hover:bg-slate-50"
                }`}>
                <RadioGroupItem value={f} id={`freq-${f}`} data-testid={`freq-${f}`} />
                <span className="text-sm text-slate-700">{tc(f)}</span>
              </label>
            ))}
          </RadioGroup>
        </div>

        <div className="mt-8 space-y-1.5">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("q_notes")}</Label>
          <Textarea data-testid="symptoms-note-input" value={s.note}
            onChange={(e) => update("symptoms", { note: e.target.value })} placeholder={t("q_notes_ph")} rows={3} />
        </div>
      </div>
    </StepShell>
  );
};
